module.exports = __webpack_public_path__ + "img/光能海岸.91cd57af.jpg";